export default __webpack_public_path__ + "static/media/gp-girl.452078ab.webp";